module.exports = __webpack_public_path__ + "static/media/PorCobrar.b38444e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo/PorCobrar.svg
// module id = 632
// module chunks = 34